// This must always be first
import "./require";

// Third-party dependencies
import "popper.js";
import "bootstrap";
import "lazysizes";
import "lazysizes/plugins/object-fit/ls.object-fit.js";
import "lazysizes/plugins/parent-fit/ls.parent-fit.js";
import "lazysizes/plugins/respimg/ls.respimg.js";
import "fluidbox";
import "smartmenus";
import "smartmenus/dist/addons/bootstrap-4/jquery.smartmenus.bootstrap-4.js";
import "./gsap.js";

// Theme scripts
import { AdvancedForm } from "./advanced-forms";
import { iframeResize, loadInFrame } from "./ajax-iframe";
import { getScrollbarWidth } from "./css-vars";
import { better_wpcf7_forms } from "./forms";
import { ajax_search } from "./search";
import { woocommerceFeatures } from "./woocommerce";
import { shareButtons } from "./share-buttons";

const $ = jQuery;

$(() => {

  $('form.af-form').each(function (this: HTMLFormElement) {
    new AdvancedForm(this);
  });

  document.documentElement.style.setProperty('--scrollbar-width', getScrollbarWidth() + 'px');

  ajax_search();
  woocommerceFeatures();
  loadInFrame(); // loads content into iframe
  iframeResize(); // Automatically resizes iframes
  shareButtons();

  better_wpcf7_forms();
  $('.gallery a.thumbnail').fluidbox();
  $('.gallery a.thumbnail img').each(function (this: HTMLImageElement) {
    if (this.src !== this.getAttribute('src')) {
      $(this).replaceWith($(this.outerHTML));
    }
  });

  // flyout menu
  $('.navbar-collapse.width').on('show.bs.collapse hide.bs.collapse', function (e) {
    $('body').toggleClass('menu-visible');
  });

});

// Add background to Top Menu dynamically
$(window).on('resize scroll', function (e) {
  if ($(window).scrollTop() > ($('.page-header .fixed-top').height()) / 2 && !$('.page-header .fixed-top').is('.scroll')) {
    $('.page-header .fixed-top').addClass('scroll');
  } else if ($(window).scrollTop() < ($('.page-header .fixed-top').height()) / 2 && $('.page-header .fixed-top').is('.scroll')) {
    $('.page-header .fixed-top').removeClass('scroll');
  }
});

// Check if small menu is open
$(".navbar-toggler").click(() => {
  $(".navbar-toggler ").hasClass("collapsed") ?
    $(".navbar.bg-dark-gradient").addClass("open") :
    $(".navbar.bg-dark-gradient").removeClass("open")
});